import * as Constants from '../constants/pet';

const initialState = {
  pet: {},
  activePetId: '',
  userPets: [],
  breeds: [],
  species: [],
  genders: [],
  neutered: [],
  spayed: [],
  medicalConditions: [],
  ownerIdentifications: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_USER_PETS_SUCCESS:
      return {
        ...state,
        userPets: action.payload,
      };
    case Constants.CREATE_PRO_PET_SUCCESS:
      return {
        ...state,
        userPets: [...state.userPets, action.payload],
      };
    case Constants.GET_PET_SUCCESS:
      return {
        ...state,
        pet: action.payload,
      };
    case Constants.GET_GENDERS_SUCCESS:
      return {
        ...state,
        genders: action.payload,
      };
    case Constants.GET_SPECIES_SUCCESS:
      return {
        ...state,
        species: action.payload,
      };
    case Constants.GET_BREEDS_SUCCESS:
      return {
        ...state,
        breeds: action.payload,
      };
    case Constants.GET_NEUTERED_SUCCESS:
      return {
        ...state,
        neutered: action.payload,
      };
    case Constants.GET_SPAYED_SUCCESS:
      return {
        ...state,
        spayed: action.payload,
      };
    case Constants.GET_MEDICAL_CONDITIONS_SUCCESS:
      return {
        ...state,
        medicalConditions: action.payload,
      };
    case Constants.GET_OWNER_IDENTIFICATIONS_SUCCESS:
      return {
        ...state,
        ownerIdentifications: action.payload,
      };
    case Constants.SET_ACTIVE_PET:
      return {
        ...state,
        activePetId: action.payload,
      };
    case Constants.SET_USER_PETS:
      return {
        ...state,
        userPets: action.payload,
      };
    default:
      return state;
  }
};
